<template>
  <Modal :id="id" :hide-header="true" :hide-footer="true">
    <div slot="body" class="modal-body p-0">
      <DetailsPane v-if="!!event" :event="event" :tab="tab" @close="close()" />
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import DetailsPane from "./DetailsPane";
export default {
  mixins: [ModalMixin],
  components: { DetailsPane },
  data() {
    return {
      id: "event-details-modal",
      event: null,
      tab: "details",
    };
  },
  mounted() {
    this.event = this.options.event;
    this.tab = _.has(this.options, "tab") ? this.options.tab : "details";
  },
};
</script>